import { useState, useEffect, useCallback, useRef } from "react";
import { TailSpin } from "react-loader-spinner";
import Dropzone from "react-dropzone";
import { UploadCloud } from "lucide-react";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import Modal from "../Modal";
import {
  Download,
  Plus,
  Search,
  SlidersHorizontal,
  X,
  Rows4,
  GridIcon,
} from "lucide-react";
import _ from "lodash";
import Select from "react-select";
import { headingData, loginSuccess } from "../../../slices/auth/login/reducer";
import { createSelector } from "reselect";
import Papa from "papaparse";
import axios from "axios";
import { PaginationState } from "@tanstack/react-table";
import { useSelector, useDispatch } from "react-redux";
import callApi from "Common/utils/apiCaller";
import { getImageUrl } from "Common/utils/ImageDomain";
import { imageUploader } from "Common/utils/imageUploader";
import { showNotification } from "Common/utils/Notification";
import PaginationContainer from "../../../pages/media/PaginationContainer";
import audio from "../../../images/Speaker_Icon.svg";
import video from "../../../images/video.svg";
import document_pdf from "../../../images/PDF_file_icon.svg";
import Drawer from "../Drawer";

const ImageView = ({ showImage, setEventData, togleImage }) => {
  const [mediaType, setMediaType] = useState<any>();
  const [render, setRender] = useState(false);
  const [loader, setLoader] = useState(false);
  const [search, setSearch] = useState<any>("");
  const [mediaData, setMediaData] = useState<any>();
  const [selectedFile, setSelectedFile] = useState<any>("");
  const [fileContent, setFileContent] = useState("");
  const [imageLink, setImageLink] = useState<any>();
  const [showModel, setShowModel] = useState<any>(false);
  const defaultToggle = () => setShowModel(!showModel);

  const [pageCount, setPageCount] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: 0,
    pageSize: 30,
  });
  const [medias, setMedias] = useState("");
  const selectProperties = createSelector(
    (state: any) => state.Login,
    (profile) => ({
      user: profile.user,
      error: profile.error,
      success: profile.success,
    })
  );

  const { error, success, user } = useSelector(selectProperties);

  //fetch media
  const debouncedHandler = useCallback(
    _.debounce(
      (
        mediaType: any,

        search: any,
        pagination: any,
        render: any
      ) => {
        return fetchDateWithFilters(
          mediaType,

          search,
          pagination,
          render
        );
      },
      700
    ),
    []
  );
  async function fetchDateWithFilters(
    mediaType: any,

    search: any,
    pagination: any,
    render: any
  ) {
    let filters: { [index: string]: any } = {};
    if (mediaType) {
      filters.media_type = mediaType;
    }

    if (search) {
      filters.qtext = search;
    }
    const localData = await callApi("v1/media/list", "post", {
      pageNum: pagination?.pageIndex + 1,
      pageSize: pagination?.pageSize,
      filters,
    });

    if (localData?.status === "Success") {
      setMediaData(localData?.data?.mediaList);
      setPageCount(
        Math.ceil(localData?.data?.mediaCount / pagination?.pageSize)
      );
      setTotalItems(localData?.data?.mediaCount);
    }
  }
  const handleDelete = async (eventData) => {
    try {
      const res = await callApi(`v1/media/${eventData?._id}/update`, "post", {
        media: { is_deleted: true },
      });
      if (res && res?.status === "Success") {
        setRender(!render);
        showNotification("Deleted successfully", "success");
      }
    } catch (e) {
      showNotification("Error occured", "error");
    }
  };
  useEffect(() => {
    debouncedHandler(mediaType, search, pagination, render);
  }, [mediaType, search, pagination, render]);

  // Picking a file only highlights it; Add Media is what uses it. If the panel is closed while a
  // file is still picked, say so instead of dropping it without a word.
  const pickedRef = useRef<any>();
  useEffect(() => {
    pickedRef.current = imageLink;
  }, [imageLink]);
  useEffect(() => {
    if (!showImage && pickedRef.current) {
      const picked = pickedRef.current;
      pickedRef.current = undefined;
      setImageLink(undefined);
      showNotification(
        `You picked ${picked.file_name || "a file"} but did not press Add Media, so it was not used.`,
        "warning"
      );
    }
  }, [showImage]);

  const filterSearchData = (e: any) => {
    const search = e.target.value;
    setSearch(search);
  };
  const options = [
    { value: "Select...", label: "Select Media Type" },
    { value: "video", label: "Video" },
    { value: "image", label: "Image" },
    { value: "audio", label: "Audio" },
    { value: "document", label: "Document" },
  ];
  const handleChange = (selectedOption: any) => {
    if (selectedOption.value === "Select...") {
      setMediaType("");
    } else {
      setMediaType(selectedOption.value);
    }
  };

  const handleAcceptedFiles = async (file: any) => {
    Object.assign(file, {
      preview: URL.createObjectURL(file),
      formattedSize: formatBytes(file.size),
    });
    setSelectedFile(file);
    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: function (results: any) {
        setFileContent(results.data);
      },
    });
  };
  const formatBytes = (bytes: any, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  };
  // useEffect(() => {
  //   async function fetchMedia(selectedFile: any, id: any) {
  //     setLoader(true);
  //     const res = await imageUploader(selectedFile, id);
  //     setLoader(false);
  //     if (res.status === "Success") {
  //       setImageLink(res.data.media);
  //       setRender(!render);
  //       showNotification("Media Uploaded", "success");
  //     }
  //   }

  //   if (selectedFile && selectedFile?.type !== "" && user && user !== "") {
  //     fetchMedia(selectedFile, user);
  //   }
  // }, [selectedFile, user]);

  useEffect(() => {
  async function fetchMedia(selectedFile: any, id: any) {
    setLoader(true);
    try {
      const res = await imageUploader(selectedFile, id);
      if (res.status === "Success") {
        setImageLink(res.data.media);
        setRender(!render);
        showNotification("Media Uploaded", "success");
      } else {
        showNotification("Upload failed", "error");
      }
    } catch (error) {
      showNotification("Error uploading media", "error");
    } finally {
      setLoader(false); // Always hide loader whether success or error
    }
  }

  if (selectedFile && selectedFile?.type !== "" && user && user !== "") {
    fetchMedia(selectedFile, user);
  }
}, [selectedFile, user]);


  return (
    <>
      <ToastContainer closeButton={false} limit={1} />
      <div>
        {/* <h6 className="mb-4 text-15">Search Media</h6> */}
        <div className="flex justify-between">
          <div className="flex">
            <div className="relative my-5 w-[250px]">
              <input
                type="text"
                className="ltr:pl-8 rtl:pr-8 search form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                placeholder="Search for media"
                autoComplete="off"
                onChange={(e) => filterSearchData(e)}
              />
              <Search className="inline-block size-4 absolute ltr:left-2.5 rtl:right-2.5 top-2.5 text-slate-500 dark:text-zink-200 fill-slate-100 dark:fill-zink-600" />
            </div>
            <div className="my-5 ml-2 w-[200px]">
              <Select
                className="border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                options={options}
                isSearchable={false}
                defaultValue={options[0]}
                onChange={(event: any) => handleChange(event)}
                id="choices-single-default"
              />
            </div>
          </div>
          <div className="flex justify-end gap-2 my-5">
            <button
              onClick={() => {
                setEventData(imageLink);
                togleImage(!showImage);
                setImageLink(undefined);
                setMediaType("");
              }}
              id="addNew2"
              disabled={!imageLink}
              title={imageLink ? "" : "Pick a file first"}
              className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Add Media
            </button>
          </div>
        </div>
        <p
          id="media-selection-hint"
          className="mb-3 text-sm text-slate-500 dark:text-zink-200"
        >
          {imageLink
            ? `Selected: ${imageLink.file_name || imageLink.media_url}. Press Add Media to use it.`
            : "Click a file, then press Add Media to use it."}
        </p>

        {!selectedFile &&
          (loader ? (
            <div className="flex justify-center">
              <TailSpin visible={true} height="50" width="50" color="#4fa94d" />
            </div>
          ) : (
            <div className="flex items-center justify-center bg-white border border-dashed rounded-md cursor-pointer dropzone border-slate-300 dropzone2 dark:bg-zink-700 dark:border-zink-500">
              <Dropzone
                multiple={false}
                onDrop={(acceptedFiles) => {
                  handleAcceptedFiles(acceptedFiles[0]);
                }}
              >
                {({ getRootProps, getInputProps }: any) => (
                  <div
                    className="w-full text-lg text-center dz-message needsclick"
                    {...getRootProps()}
                  >
                    <input {...getInputProps()} />
                    <div className="mb-0">
                      <UploadCloud className="block mx-auto size-12 text-slate-500 fill-slate-200 dark:text-zink-200 dark:fill-zink-500"></UploadCloud>
                    </div>

                    <h5 className="mb-0 font-normal text-slate-500 text-15">
                      Add Files
                    </h5>
                  </div>
                )}
              </Dropzone>
            </div>
          ))}
        {selectedFile &&
          (loader ? (
            <div className="flex justify-center" style={{ marginTop: "10px" }}>
              <TailSpin visible={true} height="50" width="50" color="#4fa94d" />
            </div>
          ) : (
            <ul className="mb-4" id="dropzone-preview">
              <li className="mt-2" id="dropzone-preview-list">
                <div className="border rounded border-slate-200 dark:border-zink-500">
                  <div className="flex justify-between p-2">
                    <div className="flex shrink-0 me-3">
                      <div className="w-[100px] h-[100px] p-2 rounded-md bg-slate-100 dark:bg-zinc-600">
                        {selectedFile?.type?.split("/")[0] === "video" ? (
                          <img
                            src={video}
                            alt={"image"}
                            className="block w-full h-full rounded-md"
                          />
                        ) : selectedFile?.type?.split("/")[0] === "audio" ? (
                          <img
                            data-dz-thumbnail
                            className="block w-full h-full rounded-md"
                            src={audio}
                            alt={"audio"}
                          />
                        ) : (
                          <img
                            data-dz-thumbnail
                            className="block w-full h-full rounded-md"
                            src={selectedFile?.preview}
                            alt={selectedFile?.name}
                          />
                        )}
                      </div>

                      <div className="grow">
                        <div className="pt-1 pl-2">
                          <h5 className="mb-1 text-15" data-dz-name>
                            {selectedFile?.name}
                          </h5>
                          <p
                            className="mb-0 text-slate-500 dark:text-zink-200"
                            data-dz-size
                          >
                            {selectedFile?.formattedSize}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="shrink-0 ms-3">
                      <button
                        data-dz-remove
                        type="button"
                        className="px-2 py-1.5 text-xs text-white bg-red-500 border-red-500 btn hover:text-white hover:bg-red-600 hover:border-red-600 focus:text-white focus:bg-red-600 focus:border-red-600 focus:ring focus:ring-red-100 active:text-white active:bg-red-600 active:border-red-600 active:ring active:ring-red-100 dark:ring-custom-400/20"
                        onClick={() => {
                          setSelectedFile(undefined);
                        }}
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          ))}
        <div
          className="h-[42vh] overflow-y-auto overflow-hidden mt-3"
          style={{
            scrollbarWidth: "none",
          }}
        >
          <div className="grid grid-cols-4 gap-4 mt-2 mb-2 auto-rows-max">
            {mediaData?.map((item) => (
              <div key={item._id}>
                <div
                  className="relative flex items-center justify-center w-40 h-40 p-2 border border-gray-400 rounded-md cursor-pointer"
                  onClick={() => setImageLink(item)}
                >
                  {item.media_type === "image" ? (
                    <img
                      src={getImageUrl(
                        `${item.media_url}${"?width=142&height=142"}`
                      )}
                      alt={item.file_name || "image"}
                      className="object-cover w-full h-full rounded"
                    />
                  ) : item.media_type === "video" ? (
                    <img
                      src={video}
                      alt="Video file"
                      className="object-contain w-full h-full rounded"
                    />
                  ) : item.media_type === "audio" ? (
                    <img
                      src={audio}
                      alt="Audio file"
                      className="object-contain w-full h-full rounded"
                    />
                  ) : item.media_type === "document" ? (
                    <img
                      src={document_pdf}
                      alt="Document file"
                      className="object-contain w-full h-full rounded"
                    />
                  ) : null}

                  <input
                    type="checkbox"
                    checked={item._id === imageLink?._id}
                    onChange={() => setImageLink(item)}
                    className="absolute w-4 h-4 pointer-events-none top-1 left-1"
                  />
                </div>
                <div className="w-40 break-words">
                  {item.file_name && (
                    <div className="my-2 text-sm text-red-500 ">
                      {item.file_name}
                    </div>
                  )}
                  {item.created_at && (
                    <div className="mb-2 text-xs text-slate-500">
                      {new Date(item.created_at).toLocaleString("en-IN", {
                        dateStyle: "medium",
                        timeStyle: "short",
                      })}
                    </div>
                  )}
                </div>
                <div className="flex justify-between pr-10">
                  <button
                    onClick={() => {
                      defaultToggle();
                      setImageLink(item);
                    }}
                    id="addNew2"
                    className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                  >
                    view
                  </button>
                  <button
                    id="close-modal4"
                    data-modal-close="addEmployeeModal"
                    className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
                    onClick={() => {
                      handleDelete(item);
                    }}
                  >
                    delete
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <PaginationContainer
        setPagination={setPagination}
        isPagination={true}
        columns={[]}
        data={mediaData || []}
        pageCount={pageCount}
        pagination={pagination}
        totalItems={totalItems}
        onPaginationChange={(updater: any) => {
          const nextState = updater(pagination);
          if (nextState?.pageIndex !== pagination?.pageIndex)
            setPagination(nextState);
        }}
        divclassName="overflow-x-auto"
        PaginationClassName="flex flex-col items-center mt-5 md:flex-row"
      />

      {/* Full-Screen Overlay */}
      {showModel && (
        <div className="fixed inset-0 flex items-center justify-center bg-[#fff] bg-opacity-100 backdrop-blur-md">
          <button
            className="absolute text-2xl font-normal text-[#111] top-4 right-4"
            onClick={() => defaultToggle()}
          >
            ✖
          </button>

          <div className="relative max-w-4xl max-h-[90vh] bg-white p-4 rounded-lg shadow-lg">
            {imageLink?.media_type === "image" && (
              <img
                src={getImageUrl(imageLink.media_url)}
                alt={imageLink.file_name || "image"}
                className="max-w-full max-h-[80vh] rounded-md"
              />
            )}
            {imageLink?.media_type === "video" && (
              <video
                src={getImageUrl(imageLink.media_url)}
                controls
                className="max-w-full max-h-[80vh] rounded-md"
              />
            )}
            {imageLink?.media_type === "audio" && (
              <audio
                src={getImageUrl(imageLink.media_url)}
                controls
                className="w-60 h-60"
              />
            )}
            {imageLink?.media_type === "document" && (
              <iframe
                src={getImageUrl(imageLink.media_url)}
                className="w-[80vh] h-[80vh] rounded-md"
              />
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default ImageView;
